export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14055.0ea64443.jpg";